import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ProgressColourPalette } from "@app/directives/_misc/v-progress-bar/v-progress-bar.component";
import { IPeripheral } from "@app/interfaces/IPeripheral";
import { SimService } from "@app/main/modules/foundation/_services/sim.service";
import { UntilDestroy } from "@ngneat/until-destroy";
import { PulseService } from "../pulse/pulse.service";
import './peripheral-device-details.component.scss';

@UntilDestroy()
@Component({
    selector: 'peripheral-device-details',
    template: require('./peripheral-device-details.component.html')
})
export class PeripheralDeviceDetails {
    @Input() peripheral: IPeripheral;
    @Output() selectChannelsTab = new EventEmitter<void>();

    

    ProgressColourPalette = ProgressColourPalette;

    loading: boolean;

    constructor() { }

    openChannelsTab(): void {
        this.selectChannelsTab.emit();
    }
}
